import React from "react";
import { createPortal } from "react-dom";
import StudentDetailFooterActions from "./StudentDetailFooterActions";
import StudentDetailInfoSection from "./StudentDetailInfoSection";
import StudentDetailProfileSection from "./StudentDetailProfileSection";
import StudentDetailContactActions from "./StudentDetailContactActions";
import StudentDetailNotesSection from "./StudentDetailNotesSection";
import StudentDetailModalHeader from "./StudentDetailModalHeader";
import StudentDetailTimelineCard from "./StudentDetailTimelineCard";

export default function StudentDetailModal({
  viewingStudent,
  detailModalPos,
  handleDetailMouseDown,
  onClose,
  visitLogs,
  attendanceLogs,
  icons,
  theme,
  faithStateStyles,
  onOpenLog,
  isTeacher,
  onShare,
  onEdit,
  onDelete,
}) {
  if (!viewingStudent) return null;

  return createPortal(
    <div
      className="fixed inset-0 bg-transparent flex items-center justify-center z-[1000] p-4 transform-gpu pointer-events-auto"
      style={{ zIndex: 1000 }}
    >
      <div
        className="bg-white rounded-[2.5rem] w-full max-w-sm shadow-2xl relative overflow-hidden border border-white/50 max-h-[85vh] flex flex-col transform-gpu pointer-events-auto"
        onClick={(e) => e.stopPropagation()}
        style={{ transform: `translate(${detailModalPos.x}px, ${detailModalPos.y}px)` }}
      >
        <StudentDetailModalHeader
          iconSrc={icons.student}
          onMouseDown={handleDetailMouseDown}
          onClose={onClose}
        />

        <div className="w-full h-full overflow-y-auto custom-scrollbar p-0">
          <div className="px-8 pb-24 pt-8 relative z-10 w-full flex flex-col">
            <StudentDetailProfileSection
              viewingStudent={viewingStudent}
              visitLogs={visitLogs}
              icons={icons}
            />

            <StudentDetailContactActions
              viewingStudent={viewingStudent}
              theme={theme}
            />

            <StudentDetailInfoSection
              viewingStudent={viewingStudent}
              faithStateStyles={faithStateStyles}
            />

            <StudentDetailTimelineCard
              viewingStudent={viewingStudent}
              visitLogs={visitLogs}
              attendanceLogs={attendanceLogs}
              icons={icons}
              onOpenLog={onOpenLog}
            />

            <StudentDetailNotesSection notes={viewingStudent.notes} />

            <StudentDetailFooterActions
              viewingStudent={viewingStudent}
              isTeacher={isTeacher}
              onShare={onShare}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
